<template>
  <div>
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @billTypeChange="loadOperateType"
    ></SiruiSearch>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :columns="columnList"
        :customVisible="true"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'enable'">
              {{ scope.row[item.field] ? '是' : '否' }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import tableMixins from '@/common/mixins/table.js';
  import SiruiTable from '@/components/SiruiTable';
  export default {
    name: 'list',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      SiruiTable,
    },
    data() {
      return {
        query: {
          billType: null,
          operateType: null,
        },
        menuButtonList: [],
        tableData: [],
        load: false,
        columnList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          { field: 'billTypeName', title: '单据类型' },
          { field: 'operateTypeName', title: '操作类型' },
          { field: 'titleTemplate', title: '标题模板' },
          { field: 'priority', title: '优先级' },
          { field: 'enable', title: '是否启用' },
          { field: 'validDate', title: '生效日期' },
          { field: 'invalidDate', title: '失效日期' },
        ],
        billTypeList: [],
        operateTypeList: [],
        multipleSelection: [],
      };
    },
    computed: {
      searchColumns() {
        return [
          {
            type: 'select',
            name: '单据类型',
            prop: 'billType',
            options: this.billTypeList,
            changeMethod: 'billTypeChange',
          },
          {
            prop: 'operateType',
            name: '操作类型',
            type: 'select',
            options: this.operateTypeList,
            disabled: this.query.billType ? false : true,
          },
          {
            prop: 'titleTemplate',
            name: '标题模板',
            type: 'input',
          },
        ];
      },
    },
    mounted() {
      this.getButtonList();
      this.loadList();
      this.getData();
    },
    methods: {
      loadList() {
        this.$axios
          .post('/component/approvalBillType/getSelectData')
          .then((res) => {
            this.billTypeList = res.data.data;
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              message: err.data.msg,
              type: 'error',
            });
          });
      },
      loadOperateType() {
        this.$axios
          .post('/component/approvalOperateType/getSelectData', { billType: this.query.billType })
          .then((res) => {
            this.operateTypeList = res.data.data;
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              message: err.data.msg,
              type: 'error',
            });
          });
      },
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      getData() {
        this.load = true;
        const query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.$axios.post('/component/approvalTitleConfig/queryPage', query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      chooseClick(type) {
        if (type === 'add') {
          this.$router.push('/todoCenter/titleConfigAdd');
        } else if (type === 'edit') {
          if (this.multipleSelection.length !== 1) {
            this.$message({
              showClose: true,
              message: '请选择一条数据进行修改',
              type: 'error',
            });
            return;
          }
          this.$router.push({
            path: '/todoCenter/titleConfigEdit',
            query: { id: this.multipleSelection[0].id },
          });
        } else if (type === 'del') {
          this.del();
        }
      },
      del() {
        this.$confirmAction()
          .then(() => {
            let ids = [];
            this.multipleSelection.map((item) => {
              ids.push(item.id);
            });
            this.$axios.post('/component/approvalTitleConfig/delete', ids).then((res) => {
              if (0 == res.data.code) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.getData();
                this.multipleSelection = [];
                this.$refs.siruiTable.clearCheckboxReserve();
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
    },
  };
</script>

<style scoped></style>
